import api from './api';

export const getSouscriptions = async (params = {}, requestConfig = {}) => {
  try {
    // Ajout de logs pour déboguer la pagination
    // console.log('🔍 Chargement souscriptions avec paramètres:', params);

    const response = await api.get('/souscriptions/', { ...requestConfig, params });

    // console.log('📊 Souscriptions reçues:', {
    //   count: response.data.length,
    //   skip: params.skip || 0,
    //   limit: params.limit || 100,
    //   expectedRange: `${(params.skip || 0) + 1}-${(params.skip || 0) + (params.limit || 100)}`
    // });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const exportSouscriptions = async (format, params = {}) => {
  try {
    const response = await api.get(`/souscriptions/export/${format}`, {
      params,
      responseType: 'blob'
    });

    const disposition = response.headers['content-disposition'];
    const filenameMatch = disposition?.match(/filename=([^;]+)/);
    const filename = filenameMatch
      ? filenameMatch[1].replace(/"/g, '')
      : `souscriptions_export.${format === 'excel' ? 'xls' : format}`;

    return { blob: response.data, filename };
  } catch (error) {
    throw error;
  }
};

export const getSouscription = async (id) => {
  try {
    const response = await api.get(`/souscriptions/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createSouscription = async (souscriptionData) => {
  try {
    const response = await api.post('/souscriptions/', souscriptionData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateSouscription = async (id, souscriptionData) => {
  try {
    const response = await api.put(`/souscriptions/${id}`, souscriptionData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Créer une souscription avec envoi automatique du proforma par email
export const createSouscriptionWithProforma = async (souscriptionData, selectedServices) => {
  try {
    const response = await api.post('/souscriptions/create-with-proforma', {
      souscription: souscriptionData,
      selected_services: selectedServices
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Modifier une souscription avec envoi automatique du proforma par email
export const updateSouscriptionWithProforma = async (id, souscriptionData, selectedServices) => {
  try {
    const response = await api.put(`/souscriptions/${id}/update-with-proforma`, {
      souscription_update: souscriptionData,
      selected_services: selectedServices
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const changerStatutSouscription = async (id, statut) => {
  try {
    const response = await api.patch(`/souscriptions/${id}/statut`, { statut });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteSouscription = async (id) => {
  try {
    const response = await api.delete(`/souscriptions/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const restoreSouscription = async (id, logementId = null) => {
  try {
    const payload = logementId ? { logement_id: logementId } : {};
    const response = await api.post(`/souscriptions/${id}/restaurer`, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Actions spécifiques pour les statuts
export const payerSouscription = async (id, file = null) => {
  try {
    const formData = new FormData();
    if (file) {
      formData.append('file', file);
    }
    const response = await api.post(`/souscriptions/${id}/payer`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const livrerSouscription = async (id) => {
  try {
    const response = await api.post(`/souscriptions/${id}/livrer`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Paiement complet avec formulaire moderne
export const payerSouscriptionComplete = async (id, montant_verse, date_versement, file = null) => {
  try {
    const formData = new FormData();
    formData.append('montant_verse', montant_verse);
    formData.append('date_versement', date_versement);
    
    if (file) {
      formData.append('file', file);
    }

    const response = await api.post(`/souscriptions/${id}/paiement-complet`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Vérifier l'éligibilité au paiement
export const verifyPaymentEligibility = async (id) => {
  try {
    const response = await api.get(`/souscriptions/${id}/verify-payment`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Télécharger la preuve de paiement
export const getPreuvePaiement = async (id) => {
  try {
    const response = await api.get(`/souscriptions/${id}/preuve-paiement`, {
      responseType: 'blob'
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Récupérer le document livrable (attestation générée lors de la livraison)
export const getDocumentLivrable = async (id) => {
  try {
    const response = await api.get(`/souscriptions/${id}/document-livrable`, {
      responseType: 'blob'
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Vérifier si le document livrable existe
export const checkDocumentLivrable = async (id) => {
  try {
    const response = await api.head(`/souscriptions/${id}/document-livrable`);
    return { exists: true };
  } catch (error) {
    if (error.response?.status === 404) {
      return { exists: false };
    }
    throw error;
  }
};

// Récupérer les statistiques des souscriptions
export const getSouscriptionsStatistiques = async () => {
  try {
    const response = await api.get('/souscriptions/statistiques');
    return response.data;
  } catch (error) {
    console.error('Erreur récupération statistiques:', error);
    // Fallback avec données par défaut
    return {
      total: 0,
      attente_paiement: 0,
      attente_livraison: 0,
      livre: 0,
      cloture: 0,
      supprimee: 0
    };
  }
};

// Énums pour les statuts
export const STATUT_SOUSCRIPTION = {
  ATTENTE_PAIEMENT: 'ATTENTE_PAIEMENT',
  ATTENTE_LIVRAISON: 'ATTENTE_LIVRAISON',
  LIVRE: 'LIVRE',
  CLOTURE: 'CLOTURE',
  SUPPRIMEE: 'SUPPRIMEE'
};
